import React, { Component } from "react";
import Link from "next/link";
import Image from "next/image";

class UserCommunityHeader extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<>
				<div className="d-flex app-header">
					<div
						style={{ zIndex: 100 }}
						className="d-flex px-3 px-lg-4 px-lg-5 py-3 justify-content-between align-items-center align-items-lg-flex-start"
					>
						{/* <MenuToggle toggle={() => setIsOpen(prevState => !prevState)} isOpen={isOpen} /> */}
						<Link href="/">
							<Image
								src={"/logos/konfhub-logo-black.svg"}
								className="nav-logo d-inline-block link-text"
								alt="Konfhub"
								width={170}
								height={45}
								style={{ cursor: "pointer" }}
							/>
						</Link>
					</div>
					<div className="d-flex flex-grow-1 justify-content-end">
						<Image
							src={"/img/my-community/beta.svg"}
							className="beta-flag"
							alt="Beta"
							width={170}
							height={45}
						/>
					</div>
				</div>
				<style jsx>{`
					.app-header {
						background: #f6f6fc;
						width: 100%;
					}

					.nav-logo {
						height: 45px;
					}

					.beta-flag {
						right: -50px !important;
					}
				`}</style>
			</>
		);
	}
}

export default UserCommunityHeader;
